<template>
  <div class="breadcrumb-bg">
    <span class="breadcrumb-item" :key="index" v-for="(item, index) in breadcrumbList">
      {{ item }}
      <em v-if="!isLast(index)" class="el-icon-arrow-right arrow-size" />
    </span>
  </div>
</template>

<script>
export default {
  name: "HBreadcrumb",
  props: {
    breadcrumbList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    }
  },
  computed: {
    isLast() {
      return (index) => {
        return index === this.breadcrumbList.length - 1
      }
    }
  }
}
</script>
<style >
  .breadcrumb-bg {
    /* height: 38px; */
    background-color: #ffffff;
    padding-left: 10px;
    padding-bottom: 0px;
    margin-bottom: 10px;
    border-radius: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/view/common/HBreadcrumb.vue